import { defineComponent, createBlock, createCommentVNode, openBlock, unref, normalizeProps, mergeProps, useCssVars, computed, createElementBlock, normalizeClass, toDisplayString } from "vue";
import { WIconStd } from "../../WIcon/WIconStd/index.js";
import { WIconExt } from "../../WIcon/WIconExt/index.js";
import { iconToProp } from "../../WIcon/index.js";
import { _export_sfc } from "../../WAccordion/index.js";
import './index.css';const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "WIcon",
  props: {
    name: {},
    url: {},
    height: {},
    width: {},
    size: {},
    color: {},
    currentColor: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return props.name ? (openBlock(), createBlock(unref(WIconStd), normalizeProps(mergeProps({ key: 0 }, props)), null, 16)) : props.url ? (openBlock(), createBlock(unref(WIconExt), normalizeProps(mergeProps({ key: 1 }, props)), null, 16)) : createCommentVNode("", true);
    };
  }
});
const BADGE_SIZES = ["sm", "md"];
const DEFAULT_BADGE_SIZE = BADGE_SIZES[1];
const BADGE_VARIANTS = [
  "dot",
  "label",
  "icon-left",
  "icon-right",
  "number"
];
const DEFAULT_BADGE_VARIANT = BADGE_VARIANTS[1];
const BADGE_SETS = [
  "custom",
  "neutral",
  "white",
  "black",
  "static-white",
  "static-black",
  "alert",
  "success",
  "accent",
  "warning",
  "disable"
];
const DEFAULT_BADGE_SET = BADGE_SETS[1];
const DATA_TEST = {
  BASE: "w-badge",
  LABEL: "w-bage-label",
  WRAPPER_CLASS: ".wrapper"
};
const _hoisted_1 = ["data-t"];
const _hoisted_2 = ["data-t"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WBadge",
  props: {
    label: { default: void 0 },
    set: { default: DEFAULT_BADGE_SET },
    size: { default: DEFAULT_BADGE_SIZE },
    variant: { default: DEFAULT_BADGE_VARIANT },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    labelColor: { default: void 0 },
    backgroundColor: { default: void 0 }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "89f4d8d4": iconColorCss.value,
      "8d3d9412": labelColorCss.value,
      "141aad8b": backgroundColorCss.value
    }));
    const props = __props;
    const classes = computed(() => [
      `--set-${props.set}`,
      `--size-${props.size}`,
      `--variant-${props.variant}`,
      {
        "--icon-color": isCustom.value && props.iconColor,
        "--label-color": isCustom.value && props.labelColor,
        "--background-color": isCustom.value && props.backgroundColor
      }
    ]);
    function formatCssVariable(color) {
      return (color == null ? void 0 : color.startsWith("--")) ? `var(${color})` : color;
    }
    const isCustom = computed(() => props.set === "custom");
    const iconComputed = computed(() => {
      return props.icon ?? iconToProp("filled-circle-info");
    });
    const isShowLabel = computed(() => {
      if (props.variant === "dot") {
        return false;
      }
      return true;
    });
    const isLeftIcon = computed(() => props.variant === "icon-left");
    const isRightIcon = computed(() => props.variant === "icon-right");
    const iconColorCss = computed(() => formatCssVariable(props.iconColor));
    const labelColorCss = computed(() => formatCssVariable(props.labelColor));
    const backgroundColorCss = computed(
      () => formatCssVariable(props.backgroundColor)
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["w-badge", classes.value]),
        "data-t": unref(DATA_TEST).BASE
      }, [
        isLeftIcon.value && iconComputed.value ? (openBlock(), createBlock(_sfc_main$1, mergeProps({
          key: 0,
          class: "w-badge__icon"
        }, iconComputed.value), null, 16)) : createCommentVNode("", true),
        _ctx.label && isShowLabel.value ? (openBlock(), createElementBlock("span", {
          key: 1,
          class: "w-badge__label",
          "data-t": unref(DATA_TEST).LABEL
        }, toDisplayString(_ctx.label), 9, _hoisted_2)) : createCommentVNode("", true),
        isRightIcon.value && iconComputed.value ? (openBlock(), createBlock(_sfc_main$1, mergeProps({
          key: 2,
          class: "w-badge__icon"
        }, iconComputed.value), null, 16)) : createCommentVNode("", true)
      ], 10, _hoisted_1);
    };
  }
});
const WBadge = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-4d6f9a87"]]);
export {
  WBadge,
  _sfc_main$1 as _sfc_main
};
